import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from './dialog.service';

export function provideDialog() {
  return makeEnvironmentProviders([importProvidersFrom(MatDialogModule), DialogService]);
}
